import { CREATE_BOOK_PROMOTION, GET_BOOKS_PROMOTIONS, GET_BOOK_PROMOTION, SET_ALL_BOOKS_PROMOTIONS, UPDATE_BOOK_PROMOTION } from "../../../reducerTypes";
  
  const initialState = {
    getData: {},
    getList: [],
  };
  
  const bookPromotiontReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_ALL_BOOKS_PROMOTIONS:
        return {
          ...state,
          getList: action.payload,
        };
      case GET_BOOKS_PROMOTIONS:
        return {
          ...state,
          getList: action.payload,
        };
      case CREATE_BOOK_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      case GET_BOOK_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      case UPDATE_BOOK_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default bookPromotiontReducer;
  